import React from "react";
import * as Icon from "react-bootstrap-icons";
import "../assets/styles/SignUp.scss";

// eslint-disable-next-line
export default function ExpiredLink() {
    return (
      <div className="errorpage" id="errorpage"  data-testid="errorpage" style={{
            display: "flex", justifyContent: "center", alignItems: "center", minHeight: "76vh"
        }}
        >
            <div className="box text-center">
                <Icon.ExclamationTriangleFill className="icon my-4" id="icon" style={{ color: "#D61B29" }} />
                <div className="title mb-4" id="message"> Link Expired </div>
                <p className="mx-4" id="text"> The invitation link is invalid or expired. Please contact your Admin.</p>
            </div>
      </div>
    );
}